import { Card, CardActionArea, CardContent, Link, Typography } from '@mui/material';
import React from 'react';
import ContentTitle from '../../layout/ContentTitle/ContentTitle';

interface Props {
  children?: React.ReactElement<unknown>;
  href: string
  title: string
  subTitle: string
}

export default function Banner(props: Props) {
  return (
    <Card sx={(theme) => ({
      textAlign: 'center',
    })}>
      <Link
        href={props.href}
        sx={{ textDecoration: 'none' }}
      >
        <CardActionArea
          sx={(theme) => ({
            '.card-summary': {
              margin: 'auto',
              fontSize: '1.1rem',
              position: 'relative',
              fontWeight: 'bold',
              width: 'fit-content',
              color: theme.palette.text.secondary,
              marginBottom: '1rem',
              '&.active': {
                '&::after': {
                  transform: 'scale(1, 1)'
                }
              },
              '&:after': {
                position: 'absolute',
                left: 0,
                content: `''`,
                width: '100%',
                height: 4,
                background: theme.palette.text.secondary,
                bottom: -1,
                transform: 'scale(0, 1)',
                transformOrigin: 'left top',
                transition: 'transform 0.3s'
              }
            },
            '&:hover .card-summary': {
              '&::after': {
                transform: 'scale(1, 1)'
              }
            }
          })}>
          <CardContent>
            <Typography
              variant="h5"
              component="div"
              color={"text.secondary"}
            >
              <ContentTitle title={props.title} />
            </Typography>
            <Typography
              className="card-summary"
              variant="body2"
            >
              {props.subTitle}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Link>
    </Card>
  )
}